<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Редактировать город
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'city-details', params: { city_id: city.id }}">← Назад к Деталям города</router-link>
    </div>

    <div class="text-right">
      <a v-if="city.id" class="red" href="#" @click.prevent="deleteCity">удалить город</a>
    </div>

    <city-edit-form
      :city="city"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getCity, deleteCity } from '@/services/city.service'
import cityEditForm from '@/components/forms/city/CityEditForm'

export default {
  name: 'city-edit',
  components: { cityEditForm },
  data () {
    return {
      city: {
        id: null,
        name: ''
      },

      errors: {
        city: {
          id: [],
          name: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.city_id !== undefined) {
      this.city.id = this.$route.params.city_id

      getCity(this.city.id).then((response) => {
        this.city = response.data
      })
    }
  },
  methods: {
    deleteCity () {
      deleteCity(this.city.id).then((response) => {
        this.showMsg('Город был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'cities' })
        return true
      }).catch(err => {
        console.log(err)
        this.showMsg('Город был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'cities' })
        return true
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// CityEdit.vue?5e4bfee8